import React from "react";
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
	CHeader,
	CSubheader,
	CFooter,
	CCardGroup,
	CButton,
	CButtonGroup,
	CCard,
	CCardBody,
	CCardFooter,
	CCardHeader,
	CCol,
	CRow,
	CPagination,
	CTooltip,
	CLink,
	CContainer,
	CHeaderBrand,
	CHeaderNav,
	CHeaderNavItem,
	CHeaderNavLink,
	CImg,
	CForm,
	CFormGroup,
	CLabel,
	CInput,
	CSelect,
} from "@coreui/react";
import { Subihutangedit } from '../components/subnav/index';
import CIcon from '@coreui/icons-react';
import { UFunc } from "../helpers/functions";
import { Konfirm } from '../helpers/onConfirm';
import { FormHutang } from '../components/index';

var pjson     = require('../../package.json');

const IHutangedit = (props) => {
	const cComponentname 	= IHutangedit.name;
	const cDispatch			= useDispatch();
	const cHistory			= useHistory();
	cDispatch({type: "set", activeRoute: props.namaRoute});

	let cFuncname;
	const {setLoading,showToast,prosesExpired}	= props;

	const obBahasa  = useSelector(state => state.listBahasa);
	const objToken	= JSON.parse(localStorage.getItem("token"));

	let vElJmlData = document.getElementById("idjmldata");
	const [uHTMLError500,setHTMLError500]	= React.useState(null);
	const uisHeaderExecuteBl				= useSelector(state => state.isHeaderExecute);
	const uisKlikTambah						= useSelector(state => state.isKlikTambah);
	const uKeywordInitObj					= useSelector(state => state.listKeyword);
	const uMaxData							= useSelector(state => state.gMaxLaporan);
	const [uTitleEdit,setTitleEdit]			= React.useState(obBahasa.caption_editpembayaranhutang || "Edit Pembayaran Hutang");

	const [uKeywordInit,setKeywordInit]		= React.useState(uKeywordInitObj.kwd_hutangedit || "");
	const [uKeywordLoad,setKeywordLoad]		= React.useState("");
	const [uDataObj,setDataObj]				= React.useState([]);

	const [uPageNow,setActivePage] 			= React.useState(1);
	const [uJmlData,setJmlData] 			= React.useState(0);
	const [uJmlHal,setJmlHal] 				= React.useState(1);
	const [uBodyInit,setBodyInit]			= React.useState(false);
	const [uTabelRowSelect,setTabelRowSelect]= React.useState(-1);

	const [uInpTabelID,setInpTabelID]		= React.useState(0);
	const [uInpHutangID,setInpHutangID]		= React.useState(0);
	const [uInpTanggal,setInpTanggal]		= React.useState(UFunc.DbDate(new Date()));
	const [uInpTanggalDt,setInpTanggalDt]	= React.useState(new Date());
	const [uInpNilaiBayar,setInpNilaiBayar]	= React.useState(0);
	const [uShowFormBl,setShowForm]			= React.useState(false);
	const [uBtnSimpanDisabledBl,setBtnSimpanDisabledBl]= React.useState(false);

	const [uFormHeader,setFormHeader]		= React.useState(obBahasa.caption_formbayarhutang);
	const [uFormDataSupplier,setFormDataSupplier]	= React.useState("");
	const [uFormDataTglHutang,setFormDataTglHutang]	= React.useState("");
	const [uFormDataTglHutangDb,setFormDataTglHutangDb]	= React.useState("");
	const [uFormDataNoNota,setFormDataNoNota]		= React.useState("");
	const [uFormDataTotalHutang,setFormDataTotalHutang]= React.useState("");
	const [uFormDataSisaHutang,setFormDataSisaHutang]= React.useState("");

	//---DIALOG_HANDLE:Harus Selalu ADA--/
	const hdlFormToggle=()=>{ setShowForm(!uShowFormBl); }
	React.useEffect(()=>{
		if(!uShowFormBl) return;

		var vTimeout = setTimeout(function(e){
			const vElFocus = document.getElementById("inptanggal");
			if(!UFunc.isEmpty(vElFocus)) vElFocus.focus();
			clearTimeout(vTimeout);
		},200);
	},[uShowFormBl]);
	React.useEffect(()=>{
		const vElBtn = document.getElementById("btnDialogSimpan");
		if(UFunc.isEmpty(vElBtn)) return;
		vElBtn.disabled = uBtnSimpanDisabledBl;
	},[uBtnSimpanDisabledBl]);
	React.useEffect(()=>{ setInpTanggalDt(UFunc.toDate(uInpTanggal)); },[uInpTanggal]);
	//---END DIALOG_HANDLE:Harus Selalu ADA--/

	React.useEffect(()=>{ setKeywordInit(uKeywordInitObj.kwd_hutangedit || ""); },[uKeywordInitObj]);
	React.useEffect(()=>{
		setTabelRowSelect(-1);
		svcloadData();
	},[uisHeaderExecuteBl]);
	React.useEffect(()=>{ loadBodyTabel(); },[uBodyInit]);
	React.useEffect(()=>{ setJmlData(uDataObj.length) },[uDataObj]);
	React.useEffect(()=>{
		let vJmlHal	= Math.ceil(uJmlData / uMaxData);
		setJmlHal(vJmlHal);//-*/
		setActivePage(uPageNow<=0?1:uPageNow);
		if(vElJmlData) vElJmlData.innerHTML = UFunc.formatAngka(uJmlData);
	},[uJmlData]);

	const hdlKembaliKlik=()=>{ cHistory.go("-1"); }
	const hdlKlikEdit=(_IDTABEL)=>{
		cFuncname	= hdlKlikEdit.name;
		_IDTABEL	= parseInt(_IDTABEL)||0;
		if(_IDTABEL <= 0) return;

		setInpTabelID(_IDTABEL);
		var vObjdx	= UFunc.getObjectIndeks(uDataObj,_IDTABEL);
		var vRowIdx	= UFunc.getTabelRowIndeks("idtabeldata","idtr"+_IDTABEL);
		setTabelRowSelect(vRowIdx);

		let vCaptionUpper	= ((uDataObj[vObjdx].tgl_bayar||"")+" "+(uDataObj[vObjdx].nama_supplier||"")).toUpperCase();

		setFormHeader(obBahasa.caption_editdata+": "+vCaptionUpper);
		setFormDataSupplier(uDataObj[vObjdx].nama_supplier||"");
		setFormDataTglHutang(uDataObj[vObjdx].tgl_hutang||"");
		setFormDataTglHutangDb(uDataObj[vObjdx].tgl_hutangdb||"");
		setFormDataTotalHutang(uDataObj[vObjdx].total_hutang||"");
		setFormDataSisaHutang(uDataObj[vObjdx].sisa_hutang||"");

		setInpTanggal((uDataObj[vObjdx].tgl_bayardb));
		setInpNilaiBayar(uDataObj[vObjdx].nilai_bayar||"0");
		setInpHutangID(uDataObj[vObjdx].id_hutang||"0");

		setShowForm(true);
	}
	const hdlKlikHapus=async(_IDTABEL)=>{
		cFuncname = hdlKlikHapus.name;

		var vRowIdx	= UFunc.getTabelRowIndeks("idtabeldata","idtr"+_IDTABEL);
		var vObjdx	= UFunc.getObjectIndeks(uDataObj,_IDTABEL);
		setTabelRowSelect(vRowIdx);

		let vConfirm	= 
		obBahasa.caption_hapusdata+": <B>"+(uDataObj[vObjdx].tgl_bayar+" "+uDataObj[vObjdx].nama_supplier).toUpperCase()+"</B>"+
		"<BR>"+obBahasa.petunjuk_hapus+
		"<BR><BR><B>"+obBahasa.confirm_hapus+"</B>"+
		"";

		if(await Konfirm(vConfirm)) svcProsesHapus(_IDTABEL);
	}

	const svcloadData=()=>{
		cFuncname	= svcloadData.name;
		setHTMLError500("");

		//console.log("("+cComponentname+") "+cFuncname+" => Proses ");

		/*//--TESTING_FRONTEND--/
		setKeywordLoad(uKeywordInit);
		let vTmpObj	= [
			{id:"1",tgl_bayar:"Kam,03 Feb 2021",tgl_bayardb:"2021-02-03",id_hutang:"1",nama_supplier:"Supplier 01",total_hutang:"100000",sisa_hutang:"100000",tgl_hutang:"Jum,02 Jan 2021",tgl_hutangdb:"2021-01-02",nilai_bayar:"50000"},
			{id:"2",tgl_bayar:"Kam,04 Feb 2021",tgl_bayardb:"2021-02-04",id_hutang:"1",nama_supplier:"Supplier 02",total_hutang:"200000",sisa_hutang:"200000",tgl_hutang:"Jum,03 Jan 2021",tgl_hutangdb:"2021-01-03",nilai_bayar:"60000"},
			{id:"3",tgl_bayar:"Kam,05 Feb 2021",tgl_bayardb:"2021-02-05",id_hutang:"1",nama_supplier:"Supplier 03",total_hutang:"300000",sisa_hutang:"300000",tgl_hutang:"Jum,04 Jan 2021",tgl_hutangdb:"2021-01-04",nilai_bayar:"70000"},
			{id:"4",tgl_bayar:"Kam,06 Feb 2021",tgl_bayardb:"2021-02-06",id_hutang:"1",nama_supplier:"Supplier 04",total_hutang:"400000",sisa_hutang:"400000",tgl_hutang:"Jum,05 Jan 2021",tgl_hutangdb:"2021-01-05",nilai_bayar:"80000"},
			{id:"5",tgl_bayar:"Kam,07 Feb 2021",tgl_bayardb:"2021-02-07",id_hutang:"1",nama_supplier:"Supplier 05",total_hutang:"500000",sisa_hutang:"500000",tgl_hutang:"Jum,06 Jan 2021",tgl_hutangdb:"2021-01-06",nilai_bayar:"90000"},
			{id:"6",tgl_bayar:"Kam,08 Feb 2021",tgl_bayardb:"2021-02-08",id_hutang:"1",nama_supplier:"Supplier 06",total_hutang:"600000",sisa_hutang:"600000",tgl_hutang:"Jum,07 Jan 2021",tgl_hutangdb:"2021-01-07",nilai_bayar:"100000"},
			{id:"7",tgl_bayar:"Kam,09 Feb 2021",tgl_bayardb:"2021-02-09",id_hutang:"1",nama_supplier:"Supplier 07",total_hutang:"700000",sisa_hutang:"700000",tgl_hutang:"Jum,08 Jan 2021",tgl_hutangdb:"2021-01-08",nilai_bayar:"110000"},
			{id:"8",tgl_bayar:"Kam,10 Feb 2021",tgl_bayardb:"2021-02-10",id_hutang:"1",nama_supplier:"Supplier 08",total_hutang:"800000",sisa_hutang:"800000",tgl_hutang:"Jum,09 Jan 2021",tgl_hutangdb:"2021-01-09",nilai_bayar:"120000"},
			{id:"9",tgl_bayar:"Kam,11 Feb 2021",tgl_bayardb:"2021-02-11",id_hutang:"1",nama_supplier:"Supplier 09",total_hutang:"900000",sisa_hutang:"900000",tgl_hutang:"Jum,10 Jan 2021",tgl_hutangdb:"2021-01-10",nilai_bayar:"130000"},
			{id:"10",tgl_bayar:"Kam,12 Feb 2021",tgl_bayardb:"2021-02-12",id_hutang:"1",nama_supplier:"Supplier 10",total_hutang:"1000000",sisa_hutang:"1000000",tgl_hutang:"Jum,11 Jan 2021",tgl_hutangdb:"2021-01-11",nilai_bayar:"140000"},
			{id:"11",tgl_bayar:"Kam,13 Feb 2021",tgl_bayardb:"2021-02-13",id_hutang:"1",nama_supplier:"Supplier 11",total_hutang:"1100000",sisa_hutang:"1100000",tgl_hutang:"Jum,12 Jan 2021",tgl_hutangdb:"2021-01-12",nilai_bayar:"150000"},
			{id:"12",tgl_bayar:"Kam,14 Feb 2021",tgl_bayardb:"2021-02-14",id_hutang:"1",nama_supplier:"Supplier 12",total_hutang:"1200000",sisa_hutang:"1200000",tgl_hutang:"Jum,13 Jan 2021",tgl_hutangdb:"2021-01-13",nilai_bayar:"160000"},
		]
		setDataObj(vTmpObj);
		return;
		//--END TESTING_FRONTEND--*/

		setDataObj([]);
		var vDATAS    = JSON.stringify({
			send_keyword : uKeywordInit,
			send_tokenauth : objToken.userinit
		});
		setKeywordLoad(uKeywordInit);
		var vURLs     = pjson.svcpage+"svc_hutang/ld_bayar";

		setLoading(true);
		setBtnSimpanDisabledBl(true);
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST", mode: "cors",
			cache: "default", body: vDATAS,
		}).then((response)=> {
			if (response.status === 200) return response.json();
		}).then((output_string) => {
			setLoading(false);
			setBtnSimpanDisabledBl(false);
			if(output_string.tampil) {
				let vTmpObj = []
				if(output_string.dataobject) {
					vTmpObj = JSON.parse(output_string.dataobject);
					setDataObj(vTmpObj);
				}
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("("+cComponentname+"-"+cFuncname+") output_string.errors : "+output_string.errors);
				var vMsg;
				if(pjson.mydefault.environment=="development")
					vMsg = output_string.errors;
				else vMsg = pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				setLoading(true);
				prosesExpired(cHistory);
			}
		}).catch((error) =>{
			setBtnSimpanDisabledBl(false);
			setLoading(false);
			console.log("("+cComponentname+"-"+cFuncname+") catch-error: "+error);
			setHTMLError500(pjson.mydefault.msg500str.join(" "));
			//cHistory.push("/error500");
		});	
	}
	const svcProsesSimpan=()=>{
		cFuncname = svcProsesSimpan.name;

		const vIdx		= UFunc.getObjectIndeks(uDataObj,uInpTabelID);
		if(vIdx < 0) return;

		/*//--TESTING_FRONTEND--/
			const vTmpObj		= uDataObj;
			vTmpObj[vIdx].nilai_bayar = (parseInt(uInpNilaiBayar)||0);
			setDataObj(vTmpObj);
			setBodyInit(!uBodyInit);

			hdlFormToggle();
			return;
		//--END TESTING_FRONTEND--*/

		var vDATAS    = JSON.stringify({
			send_hutangid : uInpHutangID,
			send_tabelid : uInpTabelID,
			send_tanggal : uInpTanggal,
			send_nilaibayar : uInpNilaiBayar,
			send_tokenauth : objToken.userinit
		});
		var vURLs     = pjson.svcpage+"svc_hutang/pr_simpan";

		//console.log("("+cComponentname+"-"+cFuncname+") [0] uKeywordInit "+uKeywordInit);

		setLoading(true);
		setBtnSimpanDisabledBl(true);
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST", mode: "cors",
			cache: "default", body: vDATAS,
		}).then((response)=> {
			if (response.status === 200) return response.json();
			//else { console.log("("+cComponentname+") [1]: response "+response.statusText); }
		}).then((output_string) => {
			setLoading(false);
			setBtnSimpanDisabledBl(false);
			if(output_string.sukses) {
				const vTmpObj		= uDataObj;
				vTmpObj[vIdx].tgl_bayar 	= output_string.tgl_bayar;
				vTmpObj[vIdx].tgl_bayardb 	= output_string.tgl_bayardb;
				vTmpObj[vIdx].nilai_bayar 	= (parseInt(uInpNilaiBayar)||0);
				setDataObj(vTmpObj);
				setBodyInit(!uBodyInit);

				hdlFormToggle();
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("("+cComponentname+"-"+cFuncname+") output_string.errors : "+output_string.errors);
				var vMsg;
				if(pjson.mydefault.environment=="development")
					vMsg = output_string.errors;
				else vMsg = pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				setShowForm(!uShowFormBl);
				setLoading(true);
				prosesExpired(cHistory);
			}
		}).catch((error) =>{
			setLoading(false);
			setBtnSimpanDisabledBl(false);
			console.log("("+cComponentname+"-"+cFuncname+") catch-error: "+error);
			var vMsg = pjson.mydefault.msg500str.join(" ");
			showToast(vMsg,"ERROR");
		});
	}
	const svcProsesHapus=(_IDTABEL)=>{
		cFuncname = svcProsesHapus.name;

		var vObjdx	= UFunc.getObjectIndeks(uDataObj,_IDTABEL);
		if(vObjdx < 0) return;

		/*//--TESTING_FRONTEND--/
			var vTmpObj = uDataObj;
			vTmpObj.splice(vObjdx,1);
			setDataObj(vTmpObj);
			setJmlData(vTmpObj.length);
			setBodyInit(!uBodyInit);
			return;
		//--END TESTING_FRONTEND--*/

		var vDATAS    = JSON.stringify({
			send_tabelid : _IDTABEL,
			send_tokenauth : objToken.userinit
		});
		var vURLs     = pjson.svcpage+"svc_hutang/pr_hapus";

		setLoading(true);
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST", mode: "cors",
			cache: "default", body: vDATAS,
		}).then((response)=> {
			if (response.status === 200) return response.json();
		}).then((output_string) => {
			setLoading(false);
			if(output_string.sukses) {
				var vTmpObj = uDataObj;
				vTmpObj.splice(vObjdx,1);
				setDataObj(vTmpObj);
				setJmlData(vTmpObj.length);
				setBodyInit(!uBodyInit);
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("("+cComponentname+"-"+cFuncname+") output_string.errors : "+output_string.errors);
				var vMsg;
				if(pjson.mydefault.environment=="development")
					vMsg = output_string.errors;
				else vMsg = pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				setLoading(true);
				prosesExpired(cHistory);
			}
		}).catch((error) =>{
			setLoading(false);
			console.log("("+cComponentname+"-"+cFuncname+") catch-error: "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}

	const loadContent=()=>{
		if(uHTMLError500)
			return ( <>{UFunc.renderHTML(uHTMLError500)}</> );

		return (
			<div className="table-responsive-sm" xs="12">
			<table className="table table-borderless table-striped table-hover" id="idtabeldata">
			<thead className="d-sm-down-none">
			<tr>
			<th width="5%" className="align-top text-center">No</th>
			<th className="align-top text-center">
				<CRow>
				<CCol sm="12" md="3" className="text-left">{obBahasa.caption_tglbayar}</CCol>
				<CCol sm="12" md="5" className="text-left">{obBahasa.caption_detilhutang}</CCol>
				<CCol sm="12" md="2" className="text-center">{obBahasa.caption_nilaibayar} (Rp)</CCol>
				<CCol sm="12" md="2" className="text-center">#</CCol>
				</CRow>
			</th>
			</tr>
			</thead>
			<tbody>{loadBodyTabel()}</tbody>
			</table>
			</div>
		);
	}
	const loadBodyTabel=()=>{
		cFuncname	= loadBodyTabel.name;
		//console.log("("+cComponentname+") "+cFuncname+" => uKeywordLoad : "+uKeywordLoad);

		var vMin= (uPageNow-1)*uMaxData;
		var vMax= (vMin+uMaxData)-1;
		var vIdxRow	= -1;
		return uDataObj.map((vItem,vKey)=>{
			const {
				id,tgl_bayar,nama_supplier,total_hutang,tgl_hutang,nilai_bayar,nama_user,
			} = vItem;

			if(vKey>=vMin && vKey<=vMax) {
				vIdxRow++;
				var vReplace 		= new RegExp(uKeywordLoad,"ig");
				let vCaptionUpper	= ((tgl_bayar||"")+""+(nama_supplier||"")).toUpperCase();

				let vSupplierNama	= uKeywordLoad=="" ? nama_supplier
					: (nama_supplier||"").replace(vReplace,"<strong><U>"+uKeywordLoad.toUpperCase()+"</U></strong>");
				let vInputer	= uKeywordLoad=="" ? (nama_user||"")
					: (nama_user||"").replace(vReplace,"<strong><U>"+uKeywordLoad.toUpperCase()+"</U></strong>");
				let vTotalHutang	= UFunc.formatAngka(total_hutang);
				let vNilaiBayar		= UFunc.formatAngka(nilai_bayar);

				return (
				<tr id={"idtr"+id} key={vKey} className={(uTabelRowSelect===vIdxRow?"classrowselect":"")}>
					<td align="right">{(vKey+1)+"."}</td>
					<td>
					<CRow>
					<CCol sm="12" md="3" className="text-left">
						<div>{tgl_bayar}</div>
						<div className="text-danger classfontsmaller">[{UFunc.renderHTML(vInputer)}]</div>
					</CCol>
					<CCol sm="12" md="5" className="text-left px-1">
					<div className="classfontlarger text-primary">{UFunc.renderHTML(vSupplierNama)}</div>
					<div className="classfontsmaller font-italic">{obBahasa.caption_tglhutang}: {tgl_hutang}</div>
					<div>{obBahasa.caption_totalhutang}: <span className="text-success">Rp {vTotalHutang}</span></div>
					</CCol>
					<CCol sm="12" md="2" className="text-right px-1">
						<span className="text-success font-weight-bolder classfontlarger">{vNilaiBayar}</span>
					</CCol>
					<CCol sm="12" md="2" className="text-center px-1">
						<div className={(objToken.userhak!="FREEROLE"&&objToken.userhak!="MANAJER" ? " d-none" : "") }>
						<CTooltip html={false} content={"--"+obBahasa.caption_setstoktambah+": "+vCaptionUpper}>
						<CLink onClick={()=>hdlKlikEdit(id)} className="classikontabel classikonedit" />
						</CTooltip>
						<CTooltip content={"--"+obBahasa.caption_setstokkurang+": "+vCaptionUpper}>
						<CLink 
							className={"classikontabel classikonhapus"}
							onClick={()=>hdlKlikHapus(id)} />
						</CTooltip>
						</div>
					</CCol>
					</CRow>
					</td>
				</tr>
				)
			}

		});
	}

	return (
		<div className="c-app c-default-layout align-items-center">
		<div className="c-wrapper">
		<CHeader withSubheader className="classheadermain text-dark">
			<CHeaderNav className="ml-3">
			<CHeaderNavLink onClick={hdlKembaliKlik}>
			<CIcon name="cil-arrow-circle-left" height="25" alt="Kembali" />
			</CHeaderNavLink>
			</CHeaderNav>

			<CHeaderBrand className="ml-1 font-weight-bold classtitle">
			<CImg src={pjson.svcpage+"images/menus_hutang.png"} height="40" alt={obBahasa.menus_hutang} />
			&nbsp;{uTitleEdit}
			</CHeaderBrand>

			<Subihutangedit {...props} />
		</CHeader>

		<div className="c-body py-2 px-4">
			<CRow className="">
			<CCol sm="12" md="10" className="m-auto">
				<CCardGroup>
				<CCard>
				<CCardHeader><strong>{obBahasa.caption_bayarthutanglist}</strong></CCardHeader>
				<CCardBody className="py-2 px-3">
				{loadContent()}
				</CCardBody>
				{(uJmlData >= uMaxData) && (
				<CCardFooter>
					<CPagination
						activePage={uPageNow}
						pages={uJmlHal}
						onActivePageChange={(i) => setActivePage(i)}
					></CPagination>
				</CCardFooter>
				)}
				</CCard>
				</CCardGroup>
			</CCol>
			</CRow>
		</div>

		<CFooter fixed={false} className="px-3 text-black-50 bg-transparent text-right ">
			<div className="my-0 " style={{fontSize:11,opacity:0.5}}>
			<span>Copyright v{pjson.version} &copy; {pjson.mydefault.prodyear} </span>
			<a href="https://www.svarna-dwipa.com" target="_blank" rel="noopener noreferrer">SvarnadwiPa</a>
			<span className="">, All Rights Reserved</span>
			</div>
		</CFooter>

		<FormHutang
			pInpTabelID={uInpTabelID}
			pInpTanggal={uInpTanggal}
			pInpNilaiBayar={uInpNilaiBayar}
			onChangeTanggal={(e)=>setInpTanggal(e.target.value)}
			onChangeNilaiBayar={(e)=>setInpNilaiBayar(e.target.value)}
			onChangeNilaiBayarNumber={(values)=>setInpNilaiBayar(values.value)}

			pDataSupplier={uFormDataSupplier}
			pDataTglHutang={uFormDataTglHutang}
			pDataTglHutangDb={uFormDataTglHutangDb}
			pDataNoNota={uFormDataNoNota}
			pDataTotalHutang={uFormDataTotalHutang}
			pDataSisaHutang={uFormDataSisaHutang}

			onProsessimpan={svcProsesSimpan}
			show={uShowFormBl} 
			dialogHeader={uFormHeader}
			toggle={hdlFormToggle}
			{...props}/>

		</div>
		</div>
	)
}

export default IHutangedit;
	